import { FC } from "react";
import kubernetesImage from "src/assets/images/kubernetes.png";
import graphImage from "src/assets/images/graph.png";
import ICONS from "src/assets/icons";
import howitsworks from "src/assets/images/howitsworks.gif";

const cards = [
  {
    id: 1,
    title: "Souscrire à Door",
    description:
      "Accédez immédiatement à un environnement Kubernetes souverain et conforme UEMOA.",
    imageBlue: kubernetesImage,
  },
  {
    id: 2,
    title: "Déployer en 1 clic",
    description:
      "Poussez votre code (GitHub, GitLab, BitBucket) et choisissez vos bases de données ou modèles IA.",

    buttonsIcons: [
      {
        label: (
          <>
            <span className="mr-1 ml-2">{ICONS.BitBucket()}</span>
            <i className="bi bi-github mr-[0.4rem]" key={1}></i>
            <i className="bi bi-gitlab mr-3" key={2}></i> Push Code
          </>
        ),
      },
      {
        label: (
          <>
            <i className="bi bi-database-fill mr-3 ml-2" key={3}></i> Base de
            données
          </>
        ),
      },
      {
        label: (
          <>
            <span className="mr-3 ml-2">{ICONS.AI()}</span> Modèle IA
          </>
        ),
      },
    ],
  },
  {
    id: 3,
    title: "Gérez vos Applications",
    description:
      "Exposez vos applications en toute confiance et de manière sécurisée via notre API Management, Door APIM.",
    buttonsIcons: [
      {
        label: <span className="ml-3">APIM</span>,
      },
      {
        label: <span className="ml-3">Canary</span>,
      },
      {
        label: <span className="ml-3">AB Testing</span>,
      },
      // {
      //   label: <span className="ml-3">Blue/Green</span>,
      // },
    ],
  },
  {
    id: 4,
    title: "Monitorer en temps réel",
    description:
      "Anticipez les anomalies grâce à des KPIs en temps réel et offrez à vos utilisateurs un service disponible en continu, 24/7, toute l'année.",
    image: graphImage,
  },
];

const Card: FC<{ card: (typeof cards)[0] }> = ({ card }) => {
  return (
    //sm:max-w-none
    <div className="flex-none min-w-0 w-full max-w-xs sm:w-[48%] md:w-[48%] lg:w-[22%] bg-[#072642] p-4 sm:p-6 rounded-2xl text-white space-y-4 flex flex-col justify-between"> 
      <div className=" flex items-center space-x-4">
        <div className="w-10 h-10 bg-transparent rounded-full border border-[#36465A] flex items-center justify-center">
          <span className="text-lg">{card.id}</span> 
        </div>
        <h3 className="text-lg font-semibold">{card.title}</h3>
      </div>
      <p className="text-sm text-gray-300">{card.description}</p>

      <div className="space-y-2">
        {card.buttonsIcons?.map((btn, index) => (
          <button
            key={index}
            className="w-full bg-[#082b49] py-2 rounded-lg text-white hover:bg-[#1865E3] border border-gray-500 flex items-center"
          >
            {btn.label}
          </button>
        ))}
      </div>

      {card.imageBlue && (
        <div className="flex justify-center bg-[#1460E7] p-4 rounded-lg">
          <img
            src={card.imageBlue}
            alt="Chart"
            className="rounded-lg w-[65%]"
          />
        </div>
      )}
      {card.image && <img src={card.image} alt="Chart" />}
    </div>
  );
};

const HowItsWorkSection: FC = () => {
  return (
    <div className="bg-gradient-to-b from-[#05132D] to-[#04132d] mb-[3rem]">
      <div className="flex items-center justify-center  mx-auto text-center p-6">
        <h1 className="text-[32px] sm:text-[40px] md:text-[48px] font-[400] leading-[1.2] mt-[5rem]">
          Comment ça{" "}
          <i className="app-title-italic text-[#20E87F] text-[48px]">
            marche ?
          </i>
        </h1>
      </div>
      <div className="flex flex-wrap justify-center items-stretch gap-[4rem] p-6 mt-[3rem]">

        {cards.map((card) => (
          <Card key={card.id} card={card} />
        ))}
      </div>
      <div className="mt-[6rem] mb-[6rem] ml-[0.5rem] mr-[0.5rem]">
        <img src={howitsworks} alt="Cloudoor" className="mx-auto h-auto" />
      </div>
    </div>
  );
};

export default HowItsWorkSection;
